/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
  GetApiV1NotificationMobileAppSharedEnrollmentTypes401,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedEnrollmentTypes.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1NotificationMobileAppSharedEnrollmentTypes } from "../../clients/notificationMobileAppController/getApiV1NotificationMobileAppSharedEnrollmentTypes.ts";

export const getApiV1NotificationMobileAppSharedEnrollmentTypesQueryKey = () =>
  [{ url: "/api/v1/notification/mobile-app/shared/enrollment-types" }] as const;

export type GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryKey =
  ReturnType<typeof getApiV1NotificationMobileAppSharedEnrollmentTypesQueryKey>;

export function getApiV1NotificationMobileAppSharedEnrollmentTypesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1NotificationMobileAppSharedEnrollmentTypesQueryKey();
  return queryOptions<
    GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
    ResponseErrorConfig<GetApiV1NotificationMobileAppSharedEnrollmentTypes401>,
    GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1NotificationMobileAppSharedEnrollmentTypes({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Lista os valores do enum EEnrollmentStatus com id e nome. **(Requer Authorization para autenticação)**
 * @summary Retorna os tipos de status de matrícula disponíveis (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/shared/enrollment-types}
 */
export function useGetApiV1NotificationMobileAppSharedEnrollmentTypes<
  TData = GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
  TQueryData = GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1NotificationMobileAppSharedEnrollmentTypesQueryResponse,
        ResponseErrorConfig<GetApiV1NotificationMobileAppSharedEnrollmentTypes401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1NotificationMobileAppSharedEnrollmentTypesQueryKey();

  const query = useQuery(
    {
      ...getApiV1NotificationMobileAppSharedEnrollmentTypesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1NotificationMobileAppSharedEnrollmentTypes401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
